'use client';

// Sentry-recommended App Router global error boundary: reports React render errors that bubble to
// the root layout (which the request/instrumentation hooks cannot catch) and renders a generic
// fallback. Only ever mounted on a catastrophic render crash — never on the happy path — so it has
// zero effect on the golden. Standard Sentry/Next boilerplate.

import * as Sentry from '@sentry/nextjs';
import NextError from 'next/error';
import { useEffect } from 'react';

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        {/* `NextError` is the default Next.js error page component. Its type definition requires a
        `statusCode` prop. Since the App Router does not expose status codes for errors, pass 0 to
        render a generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
